<template>
  <b-container>
    <indica-form
      :table-name="tableName"
      :id-to-edit="idToEdit"
      :edit-mode="false"
      :should-clear-form="false"
    />
  </b-container>
</template>
<script>
import IndicaForm from "./indica-form";

export default {
  name: "IndicaDescription",
  components: { IndicaForm },
  data() {
    return {
      tableName: "",
      tableData: {},
      idToEdit: null,
    };
  },
  created() {
    this.tableName = this.$route.meta.tableName;
    this.idToEdit = this.$route.params.id;
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>
